import { Button } from "antd";

function SecondaryButton({
  buttonName,
  onClick,
  loading,
  btnWidth,
  id,
  disableMe,
}) {
  return (
    <Button
      loading={loading}
      onClick={onClick}
      className="secondary-popup-button"
      style={{ width: btnWidth }}
      id={id}
      disabled={disableMe ? disableMe : false}
    >
      {buttonName}
    </Button>
  );
}

export default SecondaryButton;
